<template>
  <div class="container">
    <!-- 加载动画 -->
    <a-spin
      style="position: absolute;left: 0;top: 250px;right: 0;bottom: 0;margin: auto;"
      tip="Loading..."
      v-show="loading"
      size="large"
    >
    </a-spin>

    <!-- 加载动画 end-->
    <div v-show="!showIsEntry && !showIsEdit && !loading">
      <section class="basicInfo">
        <div class="title">
          <h1>{{ detail.name }}</h1>
          <span>{{ detail.phone }}</span>
        </div>
        <div>
          <span v-show="detail.gender == 1">男</span>
          <span v-show="detail.gender == 2">女</span>
          <span v-show="detail.age > 0">{{
            "&nbsp;&nbsp;|&nbsp;&nbsp;" + detail.age
          }}</span>
          <span v-show="detail.education == 1"
            >&nbsp;&nbsp;|&nbsp;&nbsp;初中及以下</span
          >
          <span v-show="detail.education == 2"
            >&nbsp;&nbsp;|&nbsp;&nbsp;中专/高中</span
          >
          <span v-show="detail.education == 3"
            >&nbsp;&nbsp;|&nbsp;&nbsp;专科</span
          >
          <span v-show="detail.education == 4"
            >&nbsp;&nbsp;|&nbsp;&nbsp;本科</span
          >
          <span v-show="detail.education == 5"
            >&nbsp;&nbsp;|&nbsp;&nbsp;硕士及以上</span
          >
        </div>
        <ul class="tagStyle">
          <li v-for="(item, i) in detail.resume_character" :key="i">
            <a-tag :color="tagColor[i]">{{ item.character_name }}</a-tag>
          </li>
        </ul>
        <ul>
          <li>
            <label>居住地：</label>
            <div>
              <p>{{ detail.address }}</p>
              <span>{{ detail.address_detail }}</span>
            </div>
          </li>
          <br />
          <li>
            <label>应聘：</label>
            <p>{{ detail.project_name + "-" + detail.role_name }}</p>
          </li>
          <br v-if="detail.resume_source_info != undefined" />
          <li>
            <label>来源类型：</label>
            <p>
              {{
                detail.resume_source_info == undefined
                  ? ""
                  : detail.resume_source_info.type
              }}
            </p>
          </li>
          <li v-if="detail.resume_source_info != undefined">
            <label>来源渠道：</label>
            <p>
              {{
                detail.resume_source_info == undefined
                  ? ""
                  : detail.resume_source_info.channel
              }}
            </p>
          </li>
          <li v-if="detail.resume_source_info != undefined">
            <label>来源账号：</label>
            <p>
              {{
                detail.resume_source_info == undefined
                  ? ""
                  : detail.resume_source_info.details
              }}
            </p>
          </li>
          <li v-show="detail.resume_skill != ''">
            <label>工作经历：</label>
            <div
              v-for="(element, j) in detail.resume_skill"
              :key="j + 'a'"
              class="skillList"
            >
              <p>{{ element.skill_name }}</p>
              <p v-show="element.proficiency == 0">未知</p>
              <p v-show="element.proficiency == 1">无经验</p>
              <p v-show="element.proficiency == 2">小于1年</p>
              <p v-show="element.proficiency == 3">1~3年</p>
              <p v-show="element.proficiency == 4">3~5年</p>
              <p v-show="element.proficiency == 5">大于5年</p>
            </div>
          </li>
          <br />
          <li>
            <label>简历创建人员：</label>
            <p>{{ detail.create_user_name }}</p>
          </li>
          <li>
            <label>简历创建时间：</label>
            <p>{{ detail.create_time }}</p>
          </li>
        </ul>
        <div class="operation">
          <a-button
            v-show="isHandle"
            style="background: #E6A23C; color: #fff"
            @click="entryPage"
            >入职</a-button
          >
          <a-button
            v-show="detail.on_job != 1"
            @click="editPage"
            style="background: #67C23A; color: #fff"
            >编辑</a-button
          >
          <a-button
            @click="communicationListPage"
            style="background: #409EFF; color: #fff"
            >沟通</a-button
          >
        </div>
      </section>
      <!-- 入离职记录 -->
      <section
        class="timeLine operationLog"
        v-show="detail.entry_leave_record != ''"
      >
        <h2>入离职记录</h2>
        <a-timeline>
          <a-timeline-item
            v-for="(item, index) in detail.entry_leave_record"
            :key="index"
            :color="item.is_leave == 1 ? 'red' : 'green'"
          >
            <ul class="operationLog-list">
              <li>
                <label>入职项目：</label>
                <p>{{ item.project_name }}</p>
              </li>
              <li v-show="item.shop_info != ''">
                <label>入职门店/区域/大仓：</label>
                <p>{{ item.shop_info.name }}</p>
              </li>
              <li v-show="item.shop_info != ''">
                <label>地址：</label>
                <p>
                  {{
                    item.shop_info.province +
                      item.shop_info.city +
                      item.shop_info.area +
                      item.shop_info.address
                  }}
                </p>
              </li>
              <li>
                <label>入职岗位：</label>
                <p>{{ item.guard_role_names }}</p>
              </li>
              <li>
                <label>工作类型：</label>
                <p v-show="item.work_type == 1">长期工</p>
                <p v-show="item.work_type == 2">临时工</p>
              </li>
              <li>
                <label>来源类型：</label>
                <p>{{ item.resume_source_info.type }}</p>
              </li>
              <li>
                <label>来源渠道：</label>
                <p>{{ item.resume_source_info.channel }}</p>
              </li>
              <li v-show="item.resume_source_info.details != ''">
                <label>来源账号：</label>
                <p>{{ item.resume_source_info.details }}</p>
              </li>
              <li>
                <label>入职日期：</label>
                <p>{{ item.entry_time }}</p>
              </li>
              <li>
                <label>入职操作时间：</label>
                <p>{{ item.create_time }}</p>
              </li>
              <li>
                <label>入职操作人员：</label>
                <p>{{ item.entry_user_name }}</p>
              </li>
              <li>
                <label>项目状态：</label>
                <p v-show="item.status == 9">待认证</p>
                <p v-show="item.status == 10">待签约</p>
                <p v-show="item.status == 11">新合同待签</p>
                <p v-show="item.status == 20">资料待审核</p>
                <p v-show="item.status == 31">资料审核驳回</p>
                <p v-show="item.status == 40">已入职</p>
                <p v-show="item.status == 50">离职合同待签</p>
                <p v-show="item.status == 51">已离职</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职时间：</label>
                <p>{{ item.leave_time }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职操作时间：</label>
                <p>{{ item.leave_create_time }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职操作人员：</label>
                <p>{{ item.leave_user_name }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职原因：</label>
                <p>{{ item.reason }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职是否结算：</label>
                <p v-show="item.is_settlement == 1">否</p>
                <p v-show="item.is_settlement == 2">是</p>
              </li>
            </ul>
          </a-timeline-item>
        </a-timeline>
      </section>
      <!-- 入离职记录 end -->
      <!-- 沟通记录 -->
      <section class="timeLine" v-if="detail.resume_communicate != ''">
        <h2>沟通记录</h2>
        <a-timeline-item
          v-for="(element, k) in detail.resume_communicate"
          :key="k + 'b'"
        >
          <h3 v-show="element.type == 1">
            {{ element.create_time + "&nbsp;&nbsp;电话" }}
          </h3>
          <h3 v-show="element.type == 2">
            {{ element.create_time + "&nbsp;&nbsp;面访" }}
          </h3>
          <h3 v-show="element.type == 3">
            {{ element.create_time + "&nbsp;&nbsp;社交APP" }}
          </h3>
          <h3 v-show="element.type == 0">
            {{ element.create_time }}
          </h3>
          <p>{{ "操作人：" + element.role_names + "-" + element.user_name }}</p>
          <p>{{ "沟通内容：" + element.communicate }}</p>
        </a-timeline-item>
      </section>
      <!-- 沟通记录 end -->
    </div>
    <!-- 增加沟通记录 -->
    <communicationList
      v-show="showIsCommunicationList"
      :communicationListID="communicationListID"
      v-on:hideIsCommunication="hideIsCommunication"
    />
    <!-- 增加沟通记录 end -->
    <!-- 入职 -->
    <entry
      v-show="showIsEntry"
      :entryDetail="entryDetail"
      v-on:hideInEntry="hideInEntry"
    />
    <!-- 入职 end -->
    <!-- 编辑 -->
    <editResume
      v-if="showIsEdit"
      :editID="editID"
      v-on:hideIsEdit="hideIsEdit"
    />
    <!-- 编辑 end -->
  </div>
</template>
<script>
import axios from "axios";
import communicationList from "@/components/resume/communicationList.vue"; //增加沟通记录
import entry from "@/components/worker/entry.vue"; //入职
import editResume from "@/components/resume/editResume.vue"; //编辑
export default {
  data() {
    return {
      detail: "",
      tagColor: [
        "pink",
        "blue",
        "purple",
        "orange",
        "red",
        "green",
        "cyan",
        "red",
        "pink",
        "orange"
      ],
      showIsCommunicationList: false,
      communicationListID: "",
      showIsEntry: false,
      entryDetail: "",
      showIsEdit: false,
      editID: "",
      loading: true,
      isHandle: false
    };
  },
  components: {
    communicationList,
    entry,
    editResume
  },
  props: {
    detailID: null
  },
  watch: {
    detailID() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailID != "") {
      this.getDetail();
    }
  },
  methods: {
    hideIsEdit() {
      this.showIsEdit = false;
      this.getDetail();
    },
    entryPage() {
      this.showIsEntry = true;
      this.entryDetail = this.detail;
      // console.log(this.entryDetail);
    },
    hideInEntry(msg) {
      this.showIsEntry = false;
      if (msg) {
        this.getDetail();
      }
    },
    editPage() {
      this.showIsEdit = true;
      this.editID = this.detail.id;
    },
    communicationListPage() {
      this.showIsCommunicationList = true;
      this.communicationListID = this.detail.resume_id;
    },
    hideIsCommunication(msg) {
      this.showIsCommunicationList = false;
      if (msg) {
        this.getDetail();
      }
    },
    getDetail() {
      this.showIsEntry = false;
      this.showIsEdit = false;
      this.loading = true;
      let roleList = window.localStorage.getItem("xnserve-authority");
      if (
        roleList.includes("项目经理") ||
        roleList.includes("项目驻场") ||
        roleList.includes("项目总监") ||
        roleList.includes("BOSS") ||
        roleList.includes("技术") ||
        roleList.includes("运营支持") ||
        roleList.includes("自招团队")
      ) {
        this.isHandle = true;
      } else {
        this.isHandle = false;
      }
      // console.log(this.isHandle);
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_New/myResumeDetail";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_id: this.detailID
        })
        .then(res => {
          if (res.data.code == 200) {
            this.detail = res.data.data;
            setTimeout(res => {
              this.loading = false;
            }, 150);
            // console.log(this.detail);
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 20px 4% 10px;
  .basicInfo {
    margin: 20px 0 10px;
    position: relative;
    .title {
      margin: 20px 0 10px;
      h1 {
        font-size: 20px;
        display: inline-block;
        margin-right: 20px;
        line-height: 22px;
      }
      span {
        display: inline-block;
        vertical-align: top;
        line-height: 22px;
        color: #333;
        font-size: 14px;
      }
    }

    > div {
      margin: 10px 0;
      > span {
        font-size: 12px;
        color: #999;
        display: inline-block;
      }
    }
    > ul {
      li {
        display: inline-block;
        margin-bottom: 10px;
        min-width: 32%;
        margin-right: 1%;
        > img {
          height: 20px;
          display: inline-block;
          margin-right: 2px;
        }
        p,
        label {
          font-size: 14px;
          line-height: 20px;
          display: inline-block;
        }
        > div {
          display: inline-block;
          vertical-align: top;
          p {
            display: block;
          }
        }
        .skillList {
          margin-right: 30px;
          p {
            display: inline-block;
          }
        }
        span {
          font-size: 12px;
          color: #999;
        }
        table {
          display: inline-block;
          vertical-align: top;
          th,
          td {
            border: 1px solid #ccc;
            padding: 4px;
            font-size: 14px;
            color: #666;
            font-weight: normal;
          }
          th {
            background: #ededed;
          }
        }
      }
    }
    .tagStyle {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
      li {
        margin-right: 10px;
        margin-bottom: 0;
        min-width: unset;
      }
    }
    .operation {
      position: absolute;
      right: 20px;
      top: 0;
      button {
        margin-bottom: 12px;
        display: block;
      }
    }
  }
  .timeLine {
    h2 {
      font-size: 16px;
      font-weight: normal;
      margin: 10px 0 20px;
    }
    h3 {
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 6px;
    }
    p {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 6px;
    }
  }
  .operationLog {
    h4 {
      font-size: 14px;
      margin-bottom: 12px;
    }
    .operationLog-list {
      > li {
        display: inline-block;
        min-width: 30%;
        margin-right: 20px;
        margin-bottom: 10px;
        p,
        label {
          display: inline-block;
          font-size: 14px;
          line-height: 20px;
          vertical-align: top;
        }
        p {
          max-width: 80%;
        }
      }
    }
  }
}
</style>
